<template>
    <div id="lt-yantr" class="mortgage-loan-limits-calc">
        <div class="container-width">
            <div class="zip-code-block">
                <zip-code-input v-model="ZipCode" :autofocus="true" @input="getLocationByZip" />
                <button class="btn btn-green" @click="getLimit(ZipCode)">View Loan Limits</button>
                <span v-show="ShowZipCodeError" class="error-msg">Please enter a valid zip code.</span>
            </div>
            <h5 class="green-text">{{ CountyName }} County 2019 Loan Limits</h5>
            <div class="loan-limit-tab">
                <ul class="tab-name">
                    <li :class="{'active': singleFamily}" @click="singleFamily=true, duplex=false, triplex=false, fourplex=false">
                        <span class="hidden-xs">Single Family<br />(1 Unit)</span>
                        <span class="visible-xs">1 Unit</span>
                    </li>
                    <li :class="{'active': duplex}" @click="singleFamily=false, duplex=true, triplex=false, fourplex=false">
                        <span class="hidden-xs">Duplex<br />(2 Units)</span>
                        <span class="visible-xs">2 Units</span>
                    </li>
                    <li :class="{'active': triplex}" @click="singleFamily=false, duplex=false, triplex=true, fourplex=false">
                        <span class="hidden-xs">Triplex<br />(3 Units)</span>
                        <span class="visible-xs">3 Units</span>
                    </li>
                    <li :class="{'active': fourplex}" @click="singleFamily=false, duplex=false, triplex=false, fourplex=true">
                        <span class="hidden-xs">Fourplex<br />(4 Units)</span>
                        <span class="visible-xs">4 Units</span>
                    </li>
                </ul>
                <div class="tab-content">
                    <div :class="{'active': singleFamily}">
                        <ul class="calc-box">
                            <li>
                                <h4>Conforming Loan Limit</h4>
                                <span>{{ LoanLimits.conforming.limit1 }}</span>
                            </li>
                            <li>
                                <h4>Fha Loan Limit</h4>
                                <span>{{ LoanLimits.fha.limit1 }}</span>
                            </li>
                            <li>
                                <h4>Va Loan Limit</h4>
                                <span>{{ LoanLimits.conforming.limit1 }}</span>
                            </li>
                        </ul>
                    </div>
                    <div :class="{'active': duplex}">
                        <ul class="calc-box">
                            <li>
                                <h4>Conforming Loan Limit</h4>
                                <span>{{ LoanLimits.conforming.limit2 }}</span>
                            </li>
                            <li>
                                <h4>Fha Loan Limit</h4>
                                <span>{{ LoanLimits.fha.limit2 }}</span>
                            </li>
                            <li>
                                <h4>Va Loan Limit</h4>
                                <span>{{ LoanLimits.conforming.limit1 }}</span>
                            </li>
                        </ul>
                    </div>
                    <div :class="{'active': triplex}">
                        <ul class="calc-box">
                            <li>
                                <h4>Conforming Loan Limit</h4>
                                <span>{{ LoanLimits.conforming.limit3 }}</span>
                            </li>
                            <li>
                                <h4>Fha Loan Limit</h4>
                                <span>{{ LoanLimits.fha.limit3 }}</span>
                            </li>
                            <li>
                                <h4>Va Loan Limit</h4>
                                <span>{{ LoanLimits.conforming.limit1 }}</span>
                            </li>
                        </ul>
                    </div>
                    <div :class="{'active': fourplex}">
                        <ul class="calc-box">
                            <li>
                                <h4>Conforming Loan Limit</h4>
                                <span>{{ LoanLimits.conforming.limit4 }}</span>
                            </li>
                            <li>
                                <h4>Fha Loan Limit</h4>
                                <span>{{ LoanLimits.fha.limit4 }}</span>
                            </li>
                            <li>
                                <h4>Va Loan Limit</h4>
                                <span>{{ LoanLimits.conforming.limit1 }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="view-free-offers">
                <h4>We've found offers for this result</h4>
                <div>
                    <button class="btn btn-blue" type="submit" @click="redirect()">{{ DestinationButtonText }}</button>
                    <advertising-disclosures v-if="DisclosureText" :disclosure-text="disclosureText" :disclosure-tokens="disclosureTokens" class="disclosures" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ZipCodeInput from '~/components/zip-code-input.vue';
    import GetLocation from '~/mixin/get-geo-location';
    import BaseMixin from '~/mixin/base-mixin';
    import StringFormat from '~/helpers/string-format';
    import GraphQLMixin from '~/mixin/graphql';
    import LimitsFromZipAll from '~/services/graphql/LimitsFromZipAll.gql';
    import { getFinancialApiUrl, setHeader } from '~/helpers/financialapi-url-env';

    export default {
        props: {
            graphQlUri: {
                default: '',
            },
            labelCountyName: {
                default: 'County Name:',
            },
            countyName: {
                default: 'Mecklenburg',
            },
            geoLocation: {
                type: Object,
                default() {
                    return {
                        zipCode: '28201',
                        city: 'Charlotte',
                        state: 'NC',
                    };
                },
            },
            loanLimits: {
                type: Object,
                default() {
                    return {
                        fha: {
                            limit1: '',
                            limit2: '',
                            limit3: '',
                            limit4: '',
                        },
                        conforming: {
                            limit1: '',
                            limit2: '',
                            limit3: '',
                            limit4: '',
                        },
                    };
                },
            },
            disclosureTokens: {
                default: '01',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            destinationButtonText: {
                default: 'Get Free Offers',
            },
            destinationLinkOrId: {
                default: 'wp-mortgage',
            },
        },
        data() {
            return {
                ZipCode: this.geoLocation.zipCode,
                ShowZipCodeError: false,
                singleFamily: true,
                duplex: false,
                triplex: false,
                fourplex: false,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,
                GraphQlUri: this.graphQlUri,
                CountyName: this.countyName,
                LoanLimits: this.loanLimits,
            };
        },
        methods: {
            getLocationByZip(zip) {
                this.ZipCode = zip;
                if (this.zipCodeValidator()) {
                    this.ShowZipCodeError = false;
                    GetLocation.methods.GetZipCode(this.ZipCode, this.checkLocationResponse);
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            updateLocation(val) {
                val.city = val.city.toLowerCase();
                val.city = StringFormat.capitalize(val.city);
            },
            zipCodeValidator() {
                const zipCodeRegEx = /^\d{5}$/;
                return zipCodeRegEx.test(this.ZipCode) && this.ZipCode !== '';
            },
            checkLocationResponse(val) {
                if (!val.err) {
                    this.updateLocation(val);
                } else {
                    this.ShowZipCodeError = true;
                }
            },
            resetFilter() {
                this.ZipCode = this.geoLocation.zipCode;
                this.getLocationByZip(this.ZipCode);
                this.ShowZipCodeError = this.ZipCode === '' && this.disableZipcodeGeo === 'true' ? false : this.ShowZipCodeError;
            },
            async getLimit(zip) {
                const variables = {
                    zip,
                    titleCase: true,
                };
                try {
                    const data = await this.graphQlQuery(LimitsFromZipAll, variables);
                    if (data) {
                        // Extract conforming data (first element of array)
                        const conformingData = data.conforming?.length > 0 ? data.conforming[0] : {};
                        // Extract fha data (first element of array)
                        const fhaData = data.fha?.length > 0 ? data.fha[0] : {};

                        // Set county name from whichever data is available
                        this.CountyName = conformingData?.countyName || fhaData?.countyName;

                        // Set FHA limits
                        if (fhaData) {
                            this.LoanLimits.fha.limit1 = this.formatMoney(fhaData.limit1LivingUnit || 0);
                            this.LoanLimits.fha.limit2 = this.formatMoney(fhaData.limit2LivingUnit || 0);
                            this.LoanLimits.fha.limit3 = this.formatMoney(fhaData.limit3LivingUnit || 0);
                            this.LoanLimits.fha.limit4 = this.formatMoney(fhaData.limit4LivingUnit || 0);
                        }

                        // Set conforming limits
                        if (conformingData) {
                            this.LoanLimits.conforming.limit1 = this.formatMoney(conformingData.limit1LivingUnit || 0);
                            this.LoanLimits.conforming.limit2 = this.formatMoney(conformingData.limit2LivingUnit || 0);
                            this.LoanLimits.conforming.limit3 = this.formatMoney(conformingData.limit3LivingUnit || 0);
                            this.LoanLimits.conforming.limit4 = this.formatMoney(conformingData.limit4LivingUnit || 0);
                        }
                    }
                } catch (e) {
                    console.warn(`Error getting county from zip code: ${e}`);
                }
            },
            formatMoney(val) {
                return val.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).split('.')[0];
            },

        },
        mounted() {
            this.GraphQlUri = this.graphQlUri !== '' ? this.graphQlUri : getFinancialApiUrl();
            this.createGraphQlClient(this.GraphQlUri, setHeader);
            if (this.ZipCode.length > 4) {
                this.getLimit(this.ZipCode);
            }
            this.getLocationByZip(this.ZipCode);
            this.ShowZipCodeError = this.ZipCode === '' && this.disableZipcodeGeo === 'true' ? false : this.ShowZipCodeError;
        },

        mixins: [GraphQLMixin, GetLocation, BaseMixin],
        components: {
            ZipCodeInput,
        },
    };

</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
